module.exports = __webpack_public_path__ + "img/plus-square.5555e929.svg";